import { render, staticRenderFns } from "./CuponeraTableComponent.vue?vue&type=template&id=7a43d38e&"
import script from "./CuponeraTableComponent.vue?vue&type=script&lang=js&"
export * from "./CuponeraTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports